<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="6"
      >
        <v-select
          id="api_key"
          :model-value="leadData.api_key"
          :items="leadProviders"
          item-title="text"
          item-value="value"
          label="API Key"
          outlined
          @update:model-value="updateLeadData({ api_key: $event })"
        />
      </v-col>

      <v-col
        cols="12"
        md="2"
        sm="2"
      >
        <v-text-field
          id="ip_address"
          :model-value="leadData.ipaddress"
          label="IP Address"
          outlined
          @update:model-value="updateLeadData({ ipaddress: $event })"
        />
      </v-col>

      <v-col
        cols="12"
        md="2"
        sm="2"
      >
        <v-text-field
          id="affiliate_id"
          :model-value="leadData.affid"
          label="Affiliate Id"
          outlined
          @update:model-value="updateLeadData({ affid: $event })"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
        sm="4"
      >
        <v-select
          id="campaign"
          :model-value="leadData.campaign"
          :items="campaigns"
          item-title="text"
          item-value="value"
          label="Campaign"
          outlined
          @update:model-value="updateLeadData({ campaign: $event })"
        />
      </v-col>

      <v-col
        v-if="isReturnCampaign"
        md="12"
        sm="12"
        offset-md="3"
      >
        <v-col
          cols="12"
          md="6"
          sm="6"
        >
          <v-alert
            v-if="customers.length > 0"
            text
            type="info"
            border="start"
          >
            Please choose the customer you want to return as.
          </v-alert>
          <v-alert
            v-else
            text
            type="error"
            border="start"
          >
            There are no customers to return as. Create a "Purchased" or "Walkup" lead first.
          </v-alert>
        </v-col>

        <v-col
          cols="12"
          md="6"
          sm="6"
        >
          <v-select
            id="customer_guid"
            :model-value="leadData.customer_guid"
            :items="customers"
            item-title="text"
            item-value="value"
            label="Customer"
            @update:model-value="updateLeadData({ customer_guid: $event })"
            @change="setReturningCustomer"
          />
        </v-col>
      </v-col>
    </v-row>
    <!--    Loan Information-->
    <v-card
      class="my-2"
      elevation="10"
    >
      <v-card-title>
        Loan Information
        <v-row class="justify-end">
          <v-col cols="2">
            <v-checkbox
              id="fund_loan"
              :model-value="leadData.fundLoan"
              label="Fund Loan"
              @update:model-value="updateLeadData({ fundLoan: $event })"
            />
          </v-col>
          <v-col cols="2">
            <v-checkbox
              id="generate_zendesk_ticket"
              :model-value="leadData.generateZendeskTicket"
              label="Generate Ticket"
              @update:model-value="updateLeadData({ generateZendeskTicket: $event })"
            />
          </v-col>
          <v-col cols="2">
            <v-checkbox
              id="refinance_loan"
              :model-value="leadData.isLoanRefinanced"
              label="Refinance Loan"
              @update:model-value="updateLeadData({ isLoanRefinanced: $event })"
            />
            <v-text-field
              v-if="leadData.isLoanRefinanced"
              id="refinance_tier"
              :model-value="leadData.refinanceTier"
              label="Refinance Tier"
              type="number"
              outlined
              :rules="[v => v >= 1 && v <= 20 || 'Between 1 and 20']"
              @update:model-value="updateLeadData({ refinanceTier: Number($event) })"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row
          v-if="isLineOfCredit"
        >
          <v-col
            cols="12"
          >
            <v-alert
              border="top"
              color="blue lighten-1"
              dark
            >
              Note: If you are trying to create a loan with funds available the
              Request Amount should be 200 greater than Initial amount.
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <v-text-field
              id="request_amount"
              :model-value="leadData.requestamount"
              label="Request Amount"
              type="number"
              outlined
              @update:model-value="updateLeadData({ requestamount: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <v-text-field
              id="initial_amount"
              :model-value="leadData.initialAmount"
              label="Initial Amount"
              type="number"
              outlined
              @update:model-value="updateLeadData({ initialAmount: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <v-text-field
              id="loan_rate"
              :model-value="leadData.loanRate"
              label="Loan Rate"
              type="number"
              outlined
              @update:model-value="updateLeadData({ loanRate: $event })"
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <v-text-field
              id="contract_date"
              :model-value="leadData.contract_date"
              label="Contract Date"
              type="date"
              outlined
              @update:model-value="updateLeadData({ contract_date: $event })"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="6"
          >
            <v-select
              id="loan_status_id"
              :model-value="leadData.loan_status_id"
              :items="loanStatuses"
              item-title="title"
              item-value="id"
              label="Loan Status"
              outlined
              @update:model-value="(value) => { updateLeadData({ loan_status_id: value }); getLoanSubStatus(value); }"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="6"
          >
            <v-select
              id="loan_substatus_id"
              :model-value="leadData.loan_sub_status_id"
              :items="computedLoanSubStatuses"
              item-title="title"
              item-value="id"
              label="Loan Sub Status"
              outlined
              @update:model-value="updateLeadData({ loan_sub_status_id: $event })"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--    End Loan Information-->
    <!--    Customer Information-->
    <v-card
      class="my-2"
      elevation="10"
    >
      <v-card-title>Customer Information</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="first_name"
              :model-value="leadData.firstname"
              label="First Name"
              outlined
              @update:model-value="updateLeadData({ firstname: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="last_name"
              :model-value="leadData.lastname"
              label="Last Name"
              outlined
              @update:model-value="updateLeadData({ lastname: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="home_phone"
              :model-value="leadData.homephone"
              label="Home Phone"
              outlined
              @update:model-value="updateLeadData({ homephone: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="email"
              :model-value="leadData.email"
              label="Email"
              outlined
              @update:model-value="updateLeadData({ email: $event })"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="address_line_1"
              :model-value="leadData.address"
              label="Address Line 1"
              outlined
              @update:model-value="updateLeadData({ address: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="address_line_2"
              :model-value="leadData.address2"
              label="Address Line 2"
              outlined
              @update:model-value="updateLeadData({ address2: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-text-field
              id="city"
              :model-value="leadData.city"
              label="City"
              outlined
              @update:model-value="updateLeadData({ city: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-select
              id="us_states"
              :model-value="leadData.state"
              label="State"
              :items="usStates"
              outlined
              @update:model-value="updateLeadData({ state: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-text-field
              id="zip"
              :model-value="leadData.zip"
              label="Zip"
              outlined
              @update:model-value="updateLeadData({ zip: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-select
              id="rent_or_own"
              :model-value="leadData.rentorown"
              label="Rent or Own?"
              :items="['O', 'R']"
              outlined
              @update:model-value="updateLeadData({ rentorown: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-text-field
              id="address_months"
              :model-value="leadData.addressmonths"
              label="Address Months"
              type="number"
              outlined
              @update:model-value="updateLeadData({ addressmonths: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-text-field
              id="address_years"
              :model-value="leadData.addressyears"
              label="Address Years"
              type="number"
              outlined
              @update:model-value="updateLeadData({ addressyears: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            lg="3"
            sm="6"
          >
            <v-select
              id="drivers_license_state"
              :model-value="leadData.dlstate"
              label="Drivers License State"
              :items="usStates"
              outlined
              @update:model-value="updateLeadData({ dlstate: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            lg="3"
            sm="6"
          >
            <v-text-field
              id="drivers_license_number"
              :model-value="leadData.dlnumber"
              label="Drivers License Number"
              outlined
              @update:model-value="updateLeadData({ dlnumber: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            lg="2"
            sm="4"
          >
            <v-select
              id="military"
              :model-value="leadData.ismilitary"
              label="Military?"
              :items="['true', 'false']"
              outlined
              @update:model-value="updateLeadData({ ismilitary: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            lg="2"
            sm="4"
          >
            <v-select
              id="citizen"
              :model-value="leadData.iscitizen"
              label="Citizen?"
              :items="['true', 'false']"
              outlined
              @update:model-value="updateLeadData({ iscitizen: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            lg="2"
            sm="4"
          >
            <v-select
              id="other_offers"
              :model-value="leadData.otheroffers"
              label="Other Offers?"
              :items="['true', 'false']"
              outlined
              @update:model-value="updateLeadData({ otheroffers: $event })"
            />
          </v-col>
          <v-col
            cols="12"
            lg="2"
            md="4"
            sm="6"
          >
            <v-text-field
              id="ssn_number"
              :model-value="leadData.ssn"
              label="SSN"
              type="number"
              outlined
              @update:model-value="updateLeadData({ ssn: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            lg="2"
            md="4"
            sm="6"
          >
            <v-text-field
              id="date_of_birth"
              :model-value="leadData.dob"
              label="Date of Birth"
              type="date"
              outlined
              @update:model-value="updateLeadData({ dob: $event })"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--    End Customer Information-->
    <!--    Employment information-->
    <v-card
      class="my-2"
      elevation="10"
    >
      <v-card-title>Employment Information</v-card-title>
      <v-card-text>
        <v-alert
          v-if="leadData.payfrequency === 'S'"
          text
          color="info"
        >
          You have selected the payment frequency <strong>semi-monthly</strong>,
          for which payments must be the first or the fifteenth!
        </v-alert>
        <v-row>
          <v-col
            cols="12"
            md="9"
          >
            <v-row>
              <v-col
                cols="12"
                lg="4"
                sm="6"
              >
                <v-text-field
                  id="employer_name"
                  :model-value="leadData.empname"
                  label="Employer Name"
                  outlined
                  @update:model-value="updateLeadData({ empname: $event })"
                />
              </v-col>

              <v-col
                cols="12"
                lg="4"
                sm="4"
              >
                <v-text-field
                  id="employer_phone"
                  :model-value="leadData.empphone"
                  label="Employer Phone"
                  outlined
                  @update:model-value="updateLeadData({ empphone: $event })"
                />
              </v-col>

              <v-col
                cols="12"
                lg="4"
                sm="2"
              >
                <v-text-field
                  id="emp_phone_ext"
                  :model-value="leadData.empphoneext"
                  label="Ext."
                  outlined
                  @update:model-value="updateLeadData({ empphoneext: $event })"
                />
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  id="hire_date"
                  :model-value="leadData.hiredate"
                  label="Hire Date"
                  type="date"
                  outlined
                  @update:model-value="updateLeadData({ hiredate: $event })"
                />
              </v-col>

              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  id="employed_months"
                  :model-value="leadData.empmonths"
                  label="Employed Months"
                  type="number"
                  outlined
                  @update:model-value="updateLeadData({ empmonths: $event })"
                />
              </v-col>

              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  id="employed_years"
                  :model-value="leadData.empyears"
                  label="Employed Years"
                  type="number"
                  outlined
                  @update:model-value="updateLeadData({ empyears: $event })"
                />
              </v-col>

              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  id="net_monthly"
                  :model-value="leadData.netmonthly"
                  label="Net Monthly"
                  type="number"
                  outlined
                  @update:model-value="updateLeadData({ netmonthly: $event })"
                />
              </v-col>

              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  id="gross_monthly"
                  :model-value="leadData.grossmonthly"
                  label="Gross Monthly"
                  type="number"
                  outlined
                  @update:model-value="updateLeadData({ grossmonthly: $event })"
                />
              </v-col>

              <v-col
                cols="12"
                sm="2"
              >
                <v-select
                  id="income_type"
                  :model-value="leadData.incometype"
                  label="Income Type?"
                  :items="incomeTypes"
                  outlined
                  @update:model-value="updateLeadData({ incometype: $event })"
                />
              </v-col>

              <v-col
                cols="12"
                sm="2"
              >
                <v-select
                  id="pay_type"
                  :model-value="leadData.paytype"
                  label="Pay Type?"
                  :items="payTypes"
                  outlined
                  @update:model-value="updateLeadData({ paytype: $event })"
                />
              </v-col>

              <v-col
                cols="12"
                sm="2"
              >
                <v-select
                  id="pay_frequency"
                  :model-value="leadData.payfrequency"
                  label="Pay Frequency"
                  :items="filterPayFrequencies"
                  outlined
                  @update:model-value="updateLeadData({ payfrequency: $event })"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="2"
            offset-md="1"
          >
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  id="last_pay_date"
                  :model-value="leadData.lastpaydate"
                  label="Last Pay Date"
                  type="date"
                  outlined
                  disabled
                  @update:model-value="updateLeadData({ lastpaydate: $event })"
                />
              </v-col>

              <v-col
                cols="12"
              >
                <v-text-field
                  id="next_pay_date"
                  :model-value="leadData.nextpaydate"
                  label="Next Pay Date"
                  type="date"
                  outlined
                  @update:model-value="updateLeadData({ nextpaydate: $event })"
                />
              </v-col>

              <v-col
                cols="12"
              >
                <v-text-field
                  id="second_pay_date"
                  :model-value="leadData.secondpaydate"
                  label="Second Pay Date"
                  type="date"
                  outlined
                  disabled
                  @update:model-value="updateLeadData({ secondpaydate: $event })"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--    End Employment information-->
    <!--    Bank information-->
    <v-card
      class="my-2"
      elevation="10"
    >
      <v-card-title>
        Bank Information
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="bank_name"
              :model-value="leadData.bankname"
              label="Bank Name"
              outlined
              @update:model-value="updateLeadData({ bankname: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="routing_number"
              :model-value="leadData.routingnumber"
              label="Routing Number"
              outlined
              @update:model-value="updateLeadData({ routingnumber: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="account_number"
              :model-value="leadData.accountnumber"
              label="Account Number"
              outlined
              @update:model-value="updateLeadData({ accountnumber: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            sm="1"
          >
            <v-select
              id="account_type"
              :model-value="leadData.accounttype"
              label="Account Type"
              :items="accountTypes"
              outlined
              @update:model-value="updateLeadData({ accounttype: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            sm="1"
          >
            <v-text-field
              id="bank_months"
              :model-value="leadData.bankmonths"
              label="Bank Months"
              type="number"
              outlined
              @update:model-value="updateLeadData({ bankmonths: $event })"
            />
          </v-col>

          <v-col
            cols="12"
            sm="1"
          >
            <v-text-field
              id="bank_years"
              :model-value="leadData.bankyears"
              label="Bank Years"
              type="number"
              outlined
              @update:model-value="updateLeadData({ bankyears: $event })"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--    End Bank information-->
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    leadData: {
      type: Object,
      default() {
        return {};
      },
    },
    leadProviders: {
      type: Array,
      default() {
        return [];
      },
    },
    campaigns: {
      type: Array,
      default() {
        return [];
      },
    },
    usStates: {
      type: Array,
      default() {
        return [];
      },
    },
    customers: {
      type: Array,
      default() {
        return [];
      },
    },
    isReturnCampaign: {
      type: Boolean,
      default: false,
    },
    loanStatuses: {
      type: Array,
      default() {
        return [];
      },
    },
    loanSubStatuses: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  emits: [
    'changedFrequency',
    'changedNextPayDate',
  ],
  data() {
    return {
      incomeTypes: [
        'E', 'D', 'S', 'U', 'P', 'O',
      ],
      payTypes: [
        'D', 'P', 'C',
      ],
      payFrequencies: [
        'W', 'B', 'S', 'M',
      ],
      accountTypes: [
        'C', 'S',
      ],
      computedLoanSubStatuses: [],
    };
  },

  computed: {
    isLineOfCredit() {
      return this.campaigns.some((campaign) => campaign.value === this.leadData.campaign && campaign.text.includes('lineOfCredit'));
    },
    filterPayFrequencies() {
      if (this.isLineOfCredit) {
        this.updateLeadData({
          payfrequency: 'B',
        });
        return this.payFrequencies.filter((freq) => freq !== 'W');
      }
      this.updateLeadData({
        payfrequency: 'W',
      });
      return this.payFrequencies;
    },
  },

  watch: {
    'leadData.campaign': {
      deep: true,
      handler() {
        if (!this.isLineOfCredit) {
          this.updateLeadData({
            initialAmount: this.leadData.requestamount,
          });
        }
      },
    },
    'leadData.payfrequency': {
      deep: true,
      handler() {
        this.$emit('changedFrequency', this.leadData.payfrequency);
      },
    },

    'leadData.nextpaydate': {
      deep: true,
      handler() {
        this.$emit('changedNextPayDate', { payFrequency: this.leadData.payfrequency, nextPayDate: this.leadData.nextpaydate });
      },
    },
  },

  mounted() {
    this.getLoanSubStatus(this.leadData.loan_status_id, false);
  },
  methods: {
    ...mapActions('testSuite', ['updateLeadData']),

    setReturningCustomer(val) {
      const customer = this.customers.find((customerN) => customerN.value === val);
      this.updateLeadData({
        return_customer: 1,
        customer_guid: val,
        firstname: (customer) ? customer.firstname : this.leadData.firstname,
        lastname: (customer) ? customer.lastname : this.leadData.lastname,
        email: (customer) ? customer.email : this.leadData.email,
        homephone: (customer) ? customer.homephone : this.leadData.homephone,
      });
    },
    getLoanSubStatus(parentId, shouldClear = true) {
      this.computedLoanSubStatuses = this.loanSubStatuses.filter((st) => st.parent === parentId);
      // Clear the selected sub-status when the parent status changes (but not on initial mount)
      if (shouldClear) {
        this.updateLeadData({
          loan_sub_status_id: null,
        });
      }
    },
  },
};
</script>
